<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // note: {
      //   backgroundImage: "url(../../assets/images/login.png)",
      //   backgroundRepeat: "no-repeat",
      //   backgroundSize: "25px auto",
      //   marginTop: "5px"
      // }
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped></style>
